export const smOnly = '(max-width: 39.9375em)'; // 639px
export const mdUp = '(min-width: 40em)'; // 640px
export const mdDown = '(max-width: 63.9375em)'; // 1023px
export const mdOnly = '(min-width: 40em) and (max-width: 63.9375em)'; // 640px - 1023px
export const lgUp = '(min-width: 64em)'; // 1024px
export const lgOnly = '(min-width: 64em) and (max-width: 74.9375em)'; // 1024px - 1199px
export const xlgUp = '(min-width: 75em)'; // 1200px
export const xxlgUp = '(min-width: 90em)'; // 1440px
export const xlgOnly = '(min-width: 75em) and (max-width: 89.9375em)'; // 1200px - 1439px
